import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
    ModalBody, ModalCloseButton, Button, Flex, FormControl,
    FormLabel, Input, FormErrorMessage, Heading, Text, useColorModeValue, useToast
} from "@chakra-ui/react";
import {useForm} from "react-hook-form";
import {postData} from "../../services/api";
import React, {useEffect, useState} from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {FaCheckCircle} from "react-icons/fa";

export default function AddCalendarModal({isOpen, onClose, selectedRental, onIcalImported}) {

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [icalData, setIcalData] = useState(null);

    const MySwal = withReactContent(Swal);
    const toast = useToast();

    const textColor = useColorModeValue("secondaryGray.900", "white");

    const {
        handleSubmit,
        register,
        formState: {errors},
        watch,
        reset
    } = useForm()

    const url = watch('url');

    useEffect(() => {
        setIcalData(null);
        if (!url) return;
        const analyzeIcal = async () => {
            setLoading(true);
            try {
                const result = await postData(`/api/rentals/dates/analyze`, {url});
                if (result) {
                    setIcalData(result);
                }
                setLoading(null);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        analyzeIcal();
    }, [url]);

    async function onSubmit(values) {
        try {
            setLoading(true);
            await postData(`/api/rentals/${selectedRental.id}/dates/import`, values);
            setLoading(false);

            onClose();
            reset();

            onIcalImported(values.url);

            MySwal.fire({
                title: <p>Kalender wurde importiert</p>,
                html: <p>Der Kalender wurde erfolgreich importiert.</p>,
                icon: 'success',
            })

        } catch (error) {
            toast({
                title: 'Kalender konnte nicht importiert werden: ' + error.message,
                status: 'error',
                isClosable: true,
            })
            setLoading(false)
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent bgColor="white">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalHeader>Buchungskalender hinterlegen</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <Text mb={5}>Hier kannst du einen iCal-Kalender importieren, um deine Belegungen automatisch zu
                            synchronisieren.</Text>
                        <FormControl mb={5} isInvalid={errors.url}>
                            <FormLabel
                                display='flex'
                                ms='4px'
                                fontSize='sm'
                                fontWeight='500'
                                color={textColor}
                                htmlFor='url'
                            >
                                <Heading size="md">Link zum iCal-Kalender:</Heading>
                            </FormLabel>
                            <Input
                                id='url'
                                fontSize='sm'
                                type='text'
                                fontWeight='500'
                                size='lg'
                                {...register('url', {
                                    required: 'Bitte geben Sie den Link zum iCal-Kalender an'
                                })}
                            />
                            <FormErrorMessage>
                                {errors.url && errors.url.message}
                            </FormErrorMessage>
                        </FormControl>
                        {icalData?.count > 0 &&
                            <Flex alignItems={'center'} gap={2}><Text>Wir haben {icalData.count} Termine
                                gefunden</Text><FaCheckCircle color="green"/></Flex>}
                    </ModalBody>

                    <ModalFooter>
                        <Button variant='ghost' mr={3} onClick={onClose}>
                            Schließen
                        </Button>
                        <Button
                            isLoading={loading}
                            isDisabled={!icalData || icalData.count <= 0}
                            variant={'brand'}
                            type="submit"
                        >
                            Buchungskalender verknüpfen
                        </Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
}
